import { authHeaders, invokeApi, postRequest } from "../components/network/apiclient";
import { productsEndpoint } from "./endpoint";

export const fetchProducts = (token, onSuccess, onError, searchValue, shopNames, onlyAvailable, maxResults, minPrice, maxPrice) =>
    invokeApi(postRequest(productsEndpoint.searchPath(), authHeaders(token), {
        query: searchValue,
        shopNames,
        onlyAvailable,
        maxResults,
        minPrice,
        maxPrice
    }), onSuccess, onError);
